module.exports = __webpack_public_path__ + "static/media/icon-process-title.415c715f.svg";